import { MediaToolsProviderService } from '@addins/core/singlecallcard';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Tool } from '@services/tools';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { MediaSource } from '../../../schema/enums/media-source';
import { AttachmentService } from '../../attachment/attachment.service';
import { TextMessageService } from '../../text-message/text-message.service';

@AddinExecute({
  name: 'Add media tools'
})
@Injectable()
export class MediaToolsService extends Execute {
  public constructor(
    private mediaToolsProvider: MediaToolsProviderService,
    private attachments: AttachmentService,
    private textMessage: TextMessageService,
    private platform: Platform
  ) {
    super();
  }

  execute() {
    const mediaMessageTool = new Tool('SagaSchema.MediaMessage', 'text', '', 0, callcard => this.textMessage.open());
    this.mediaToolsProvider.register(mediaMessageTool);

    const cameraTool = new Tool('Saga.AttachmentType.Picture', 'camera', '', 1, callcard =>
      this.createMediaMessage(callcard.ObjGuid, MediaSource.Camera)
    );
    this.mediaToolsProvider.register(cameraTool);

    if (this.platform.is('cordova')) {
      const galleryTool = new Tool('Saga.AttachmentType.Gallery', 'image', '', 2, callcard =>
        this.createMediaMessage(callcard.ObjGuid, MediaSource.Gallery)
      );
      this.mediaToolsProvider.register(galleryTool);
    }

    const videoTool = new Tool('Saga.AttachmentType.Camera', 'videocam', '', 3, callcard =>
      this.attachments.createMediaMessage(callcard.ObjGuid, MediaSource.Video)
    );
    this.mediaToolsProvider.register(videoTool);
  }

  private createMediaMessage(callcardId: string, source: MediaSource) {
    this.attachments.createMediaMessage(callcardId, source);
  }
}
